const $21e56d403ffb83d8$var$clientId = "fappen";
async function $21e56d403ffb83d8$export$8d4b3cd2c3841e7b(scopes) {
    const redirectUri = "http://localhost:1234/";
    const issuerAuthEndpoint = "http://127.0.0.1:8000/o/authorize";
    // CSRF protection
    const state = crypto.randomUUID();
    // PKCE
    const verifier = crypto.randomUUID() + crypto.randomUUID();
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const hash = await crypto.subtle.digest("SHA-256", data);
    const challenge = btoa(String.fromCharCode(...new Uint8Array(hash))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    sessionStorage.setItem("oidc_state", state);
    sessionStorage.setItem("pkce_verifier", verifier);
    const params = new URLSearchParams({
        client_id: $21e56d403ffb83d8$var$clientId,
        redirect_uri: redirectUri,
        response_type: "code",
        scope: scopes.join(" "),
        state: state,
        code_challenge: challenge,
        code_challenge_method: "S256"
    });
    window.location.href = `${issuerAuthEndpoint}?${params.toString()}`;
}
document.querySelectorAll(".fclub-sso-button").forEach((button)=>{
    button.addEventListener("click", ()=>{
        const scopes = button.dataset.scopes?.split(" ") ?? [];
        $21e56d403ffb83d8$export$8d4b3cd2c3841e7b(scopes);
    });
});


//# sourceMappingURL=pages.68ddc819.js.map
